import React from 'react';

class AccountSettingsHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <div className="account-settings-header-body pl-sm-4">
          <div className="title-bar-without-breadcrumbs mr-0 ml-0 row">
            <div className="title-text-large">Account Settings</div>
          </div>
        </div>
        <div className="gradient-divider" />
      </div>
    );
  }
}

export default AccountSettingsHeader;
